//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "demand_info",
  data(){
    const validateDemandSize = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('t.demand_form_validate_error_tip_size')))
      } else {
        return callback()
      }
    }
    const validateDemandType = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('t.demand_form_validate_error_tip_type')))
      } else {
        return callback()
      }
    }
    const validateDemandQuantity = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('t.demand_form_validate_error_tip_quantity')))
      } else {
        return callback()
      }
    }
    const validateDemandCondition = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('t.demand_form_validate_error_tip_condition')))
      } else {
        return callback()
      }
    }
    const validateDemandLastPickupDate = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('t.demand_form_validate_error_lastPickUpDate')))
      } else {
        return callback()
      }
    }
    const validateDemandPickupLoc = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('t.demand_form_validate_error_tip_pickUpLocation')))
      } else {
        return callback()
      }
    }
    return{
      demandForm:{
        size: '',
        type: '',
        qty: '',
        containerStatus: '',
        forklift: 'yes',
        lockBox: 'yes',
        pickupDate: '',
        pickupLoc: '',
        remark: ''
      },
      demandRules: {
        size: [{ required: true, validator: validateDemandSize, trigger: 'blur' }],
        type: [{ required: true, validator: validateDemandType, trigger: 'blur' }],
        qty: [{ required: true, validator: validateDemandQuantity, trigger: 'blur' }],
        containerStatus: [{ required: true, validator: validateDemandCondition, trigger: 'blur' }],
        pickupLoc: [{ required: true, validator: validateDemandPickupLoc, trigger: 'blur' }],
        pickupDate: [{ required: true, validator: validateDemandLastPickupDate, trigger: 'blur' }],
      },
      showAddDemandDialog: false,
      tipContent: '',
      demandInfoList:[],
      isEmpty: false,
      showTip: false,
      currentRecordId:'',
      portNameOptions: [],
      loading: false,
      currentRecordNo: '',
      showDeleteInquiryDialog: false
    }
  },
  methods:{
    async getDemandInfo(){
      const result = await this.$axios.get('/bk/demand/myDemand');
      if(result === 401){
        localStorage.setItem("prePath", location.hash.split('#').length > 1 ? location.hash.split('#')[1] : '');
        this.$router.push({
          path:'/login'
        })
      }
      if(result.resultList != null ){
        this.demandInfoList = result.resultList;
      }
      this.isEmpty = this.demandInfoList.length === 0;
    },
    handleCancelDemand(demandNo){
      this.currentRecordNo = demandNo
      this.showDeleteInquiryDialog = true;
    },
    async cancelDemand(){
      const params = {
        demandNo: this.currentRecordNo
      }
      const result = await this.$axios.post('/bk/demand/cancelDemand', params);
      if(result === 401){
        localStorage.setItem("prePath", location.hash.split('#').length > 1 ? location.hash.split('#')[1] : '');
        this.$router.push({
          path:'/login'
        })
      }else if(result === 'success'){
        this.tipContent = this.$t('t.demand_cancel_resource_success');
        this.showDeleteInquiryDialog = false
        this.showTip = true;
        this.$refs.demandForm.resetFields()
      }else{
        this.$message.error(this.$t('t.contact_IT'))
      }
    },
    async addDemandInfo(){
      await this.$refs.demandForm.validate()
      this.demandForm.sizeType = this.demandForm.size + this.demandForm.type;
      this.demandForm.pickupDate = this.dateFormat(this.demandForm.pickupDate);
      const params = {
        ...this.demandForm
      }
      const result = await this.$axios.post('/bk/demand/addDemandDetail', params);
      if(result === 401){
        localStorage.setItem("prePath", location.hash.split('#').length > 1 ? location.hash.split('#')[1] : '');
        this.$router.push({
          path:'/login'
        })
      }else if(result === 'success'){
        this.showAddDemandDialog = false
        this.tipContent = this.$t('t.demand_add_resource_success');
        this.showTip = true;
        this.$refs.demandForm.resetFields()
      }else{
        this.$message.error(this.$t('t.contact_IT'))
      }
    },
    handleClose(){
      this.showTip = false
      this.getDemandInfo();
    },
    dateFormat(dateStr){
      const date = new Date(dateStr);
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();

      const formattedMonth = month < 10 ? `0${month}` : month;
      const formattedDay = day < 10 ? `0${day}` : day;

      const formattedDate = `${year}-${formattedMonth}-${formattedDay}`;
      return formattedDate;
    },
    async searchPort(query){
      try {
        const param = {
          portName: query
        }
        this.loading = true;
        const res = await this.$axios.get('/bk/port/searchPort', {
          params: param
        })
        this.loading = false;
        this.portNameOptions = res;
      } catch (e) {
        console.log(e, 'e')
      }
    },
  },
  created() {
    if(localStorage.getItem('lang')){
      this.$i18n.locale = localStorage.getItem('lang');
    }
    this.getDemandInfo();
    this.searchPort('SHA');
  },
  computed: {
    currentLang () {
      return this.$i18n.locale
    }
  },
}
